import React, { useEffect, Fragment } from 'react';
import {
    changeNameAll,
    changeTitle1All,
    changeTitle2All,
    changeTitle3All,
    changeDepartment1All,
    changeDepartment2All,
    changePhoneAll,
    changeFaxAll,
    changeEmailAll,
    changeAddressAll,
    changeCityAll,
    changeStateAll,
    changeZipAll,
    changeLocationNamesAll,
    changeLocationPhonesAll,
    changeLocationFaxesAll,
    changeLocationAddresses1All,
    changeLocationCitiesAll,
    changeLocationStatesAll,
    changeLocationZipsAll,
    changeLocationSuitesAll,
    changeLocationsAll,
    changeOpen1All,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP1T9 = React.memo((props) => {
    useEffect(() => {
        changeNameAll(props.name);
    }, [props.name]);

    useEffect(() => {
        changeTitle1All(props.title1);
    }, [props.title1]);

    useEffect(() => {
        changeTitle2All(props.title2);
    }, [props.title2]);

    useEffect(() => {
        changeTitle3All(props.title3);
    }, [props.title3]);

    useEffect(() => {
        changeDepartment1All(props.department1);
    }, [props.department1]);

    useEffect(() => {
        changeDepartment2All(props.department2);
    }, [props.department2]);

    useEffect(() => {
        changePhoneAll(props.phone);
    }, [props.phone]);

    useEffect(() => {
        changeFaxAll(props.fax);
    }, [props.fax]);

    useEffect(() => {
        changeEmailAll(props.email);
    }, [props.email]);

    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeCityAll(props.city);
    }, [props.city]);

    useEffect(() => {
        changeStateAll(props.state);
    }, [props.state]);

    useEffect(() => {
        changeZipAll(props.zip);
    }, [props.zip]);

    useEffect(() => {
        changeLocationNamesAll(props.locationNames);
    }, [props.locationNames]);

    useEffect(() => {
        changeLocationPhonesAll(props.locationPhones);
    }, [props.locationPhones]);

    useEffect(() => {
        changeLocationFaxesAll(props.locationFaxes);
    }, [props.locationFaxes]);

    useEffect(() => {
        changeLocationAddresses1All(props.locationAddresses1);
    }, [props.locationAddresses1]);

    useEffect(() => {
        changeLocationCitiesAll(props.locationCities);
    }, [props.locationCities]);

    useEffect(() => {
        changeLocationStatesAll(props.locationStates);
    }, [props.locationStates]);

    useEffect(() => {
        changeLocationZipsAll(props.locationZips);
    }, [props.locationZips]);

    useEffect(() => {
        changeOpen1All(props.open1);
    }, [props.open1]);

    useEffect(() => {
        changeLocationSuitesAll(props.locationSuites);
    }, [props.locationSuites]);

    useEffect(() => {
        changeLocationsAll(props.locations);
    }, [props.locations]);

    const setLocationElement = (elements, setFunction, index, value) => {
        const elementsCopy = [...elements];
        elementsCopy[index] = value;
        setFunction(elementsCopy);
    };

    let paperBullet = null;
    if (parseInt(props.stock) === 1) {
        paperBullet = <li>Good</li>;
    } else if (parseInt(props.stock) === 2) {
        paperBullet = <li>Better</li>;
    } else if (parseInt(props.stock) === 3) {
        paperBullet = <li>Best</li>;
    }

    const renderLocations = () => {
        let elements = [];
        for (let i = 0; i < props.locations; i++) {
            elements.push(
                <Fragment>
                    <h6>Location {i + 1}:</h6>
                    <TextField
                        required
                        label="Name"
                        placeholder="Clinic Name"
                        // limit={43}
                        value={props.locationNames[i]}
                        setFunction={setLocationElement.bind(this, props.locationNames, props.setLocationNames, i)}
                    />
                    <TextField
                        required
                        label="Address Line 1"
                        // limit={54}
                        value={props.locationAddresses1[i]}
                        setFunction={setLocationElement.bind(this, props.locationAddresses1, props.setLocationAddresses1, i)}
                    />
                    <TextField
                        label="Suite/Building #"
                        // limit={54}
                        value={props.locationSuites[i]}
                        setFunction={setLocationElement.bind(this, props.locationSuites, props.setLocationSuites, i)}
                    />
                    <TextField
                        required
                        label="City"
                        // limit={20}
                        value={props.locationCities[i]}
                        setFunction={setLocationElement.bind(this, props.locationCities, props.setLocationCities, i)}
                    />
                    <TextField
                        required
                        label="State"
                        // limit={20}
                        value={props.locationStates[i]}
                        setFunction={setLocationElement.bind(this, props.locationStates, props.setLocationStates, i)}
                    />
                    <TextField
                        required
                        label="zip"
                        // limit={20}
                        value={props.locationZips[i]}
                        setFunction={setLocationElement.bind(this, props.locationZips, props.setLocationZips, i)}
                    />
                    <TextField
                        required
                        isPhone
                        phoneFormat={3}
                        label="Phone"
                        // limit={54}
                        value={props.locationPhones[i]}
                        setFunction={setLocationElement.bind(this, props.locationPhones, props.setLocationPhones, i)}
                    />
                    <TextField
                        isPhone
                        phoneFormat={3}
                        label="Fax"
                        // limit={54}
                        value={props.locationFaxes[i]}
                        setFunction={setLocationElement.bind(this, props.locationFaxes, props.setLocationFaxes, i)}
                    />
                </Fragment>
            );
        }

        return elements;
    };

    return (
        <form action="">
            <hr />
            <TextField
                required
                label="Name"
                placeholder="Name and credentials"
                // limit={38}
                value={props.name}
                setFunction={props.setName}
            />
            <TextField
                required
                label="Title 1"
                // limit={45}
                value={props.title1}
                setFunction={props.setTitle1}
            />
            <TextField
                label="Title 2"
                // limit={45}
                value={props.title2}
                setFunction={props.setTitle2}
            />
            <TextField
                label="Title 3"
                // limit={45}
                value={props.title3}
                setFunction={props.setTitle3}
            />
            <TextField
                required
                label="Clinic Name 1"
                // limit={35}
                value={props.department1}
                setFunction={props.setDepartment1}
                placeholder="Clinic Name or Specialty line 1"
            />
            <TextField
                label="Clinic Name 2"
                // limit={35}
                value={props.department2}
                setFunction={props.setDepartment2}
                placeholder="Clinic Name or Specialty line 2"
            />
            <hr />
            <TextField
                required
                label="Address 1"
                // limit={37}
                value={props.address}
                setFunction={props.setAddress}
                placeholder="Address Line 1"
            />
            <TextField
                label="Suite/Building #"
                // limit={37}
                value={props.open1}
                setFunction={props.setOpen1}
                placeholder="Suite/Building #"
            />
            <TextField
                required
                label="City"
                // limit={16}
                value={props.city}
                setFunction={props.setCity}
            />
            <TextField
                required
                label="State"
                // limit={16}
                value={props.state}
                setFunction={props.setState}
            />
            <TextField
                required
                label="Zip"
                // limit={10}
                value={props.zip}
                setFunction={props.setZip}
            />
            <TextField
                required
                isPhone
                phoneFormat={3}
                label="Phone"
                value={props.phone}
                setFunction={props.setPhone}
                placeholder="Main or direct phone number"
            />
            <TextField
                isPhone
                phoneFormat={3}
                label="Fax"
                value={props.fax}
                setFunction={props.setFax}
                placeholder="Fax number"
            />
            <TextField
                label="Email"
                // limit={37}
                value={props.email}
                setFunction={props.setEmail}
            />
            <hr />
            <SelectField
                required
                label="Select Number of Locations"
                value={props.locations}
                setFunction={props.setLocations}
                options={[
                    { value: 0, label: 0 },
                    { value: 1, label: 1 },
                    { value: 2, label: 2 },
                    { value: 3, label: 3 },
                ]}
            />
            <hr />
            {renderLocations()}
            <hr />
            <SelectField
                required
                label="Stock"
                value={props.stock}
                setFunction={props.setStock}
                options={[
                    { value: '', label: 'Select option' },
                    { value: 1, label: 'Good' },
                    { value: 2, label: 'Better' },
                    { value: 3, label: 'Best' },
                ]}
            />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                    { value: '1500', label: '1500' },
                    { value: '2000', label: '2000' },
                    { value: '5000', label: '5000' },
                    { value: '10000', label: '10000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> UTHealth and UT Physicians Appointment Card Reminder</div>
                <div className="description-list">
                    <span className="label">Description:</span>
                    <ul>
                        <li>Variables both sides</li>
                        <li>Size 3.5x2</li>
                        <li>Double sided </li>
                        <li>Color on both sides</li>
                        {paperBullet}
                    </ul>
                </div>
            </div>
            <h5>Pricing</h5>
            <div className="pricing-container">
                <table className="table table-sm table-hover table-striped">
                    <thead>
                        <tr>
                            <th className="text-right">Quantity</th>
                            <th className="text-right">Good</th>
                            <th className="text-right">Better</th>
                            <th className="text-right">Best</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-right">250</td>
                            <td className="text-right">$35.00</td>
                            <td className="text-right">$45.00</td>
                            <td className="text-right">$55.00</td>
                        </tr>
                        <tr>
                            <td className="text-right">500</td>
                            <td className="text-right">$40.00</td>
                            <td className="text-right">$50.00</td>
                            <td className="text-right">$65.00</td>
                        </tr>
                        <tr>
                            <td className="text-right">1000</td>
                            <td className="text-right">$55.00</td>
                            <td className="text-right">$65.00</td>
                            <td className="text-right">$75.00</td>
                        </tr>
                        <tr>
                            <td className="text-right">1500</td>
                            <td className="text-right">$80.00</td>
                            <td className="text-right">$90.00</td>
                            <td className="text-right">$100.00</td>
                        </tr>
                        <tr>
                            <td className="text-right">2000</td>
                            <td className="text-right">$110.00</td>
                            <td className="text-right">$120.00</td>
                            <td className="text-right">$130.00</td>
                        </tr>
                        <tr>
                            <td className="text-right">5000</td>
                            <td className="text-right">$165.00</td>
                            <td className="text-right">$175.00</td>
                            <td className="text-right">$185.00</td>
                        </tr>
                        <tr>
                            <td className="text-right">10000</td>
                            <td className="text-right">$235.00</td>
                            <td className="text-right">$245.00</td>
                            <td className="text-right">$255.00</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </form>
    );
});

FormP1T9.propTypes = {

}

export default FormP1T9;
